export default __webpack_public_path__ + "static/media/speed-2.ec2eb454.svg";